import { AdversariesInfoLayer } from "./AdversariesInfoLayer";
import { GameVars } from "../../GameVars";
import { GameConstants } from "../../GameConstants";
import { Background } from "../background/Background";
import { BootScene } from "../BootScene";
import { AudioManager } from "../../managers/AudioManager";
import { GameTitleContainer } from "./GameTitleContainer";
import { Table } from "../room/Table";
import { Button } from "../../utils/Button";
import { GameManager } from "../../managers/GameManager";
import { SplashBanan as SplashBanana } from "./SplashBanana";
import { Translation } from "../../Translation";
import { LanguageSelectionLayer } from "./LanguageSelectionLayer";
import { MockAd } from "../../helpers/MockAd";
import { GDAd } from "../../helpers/GDAd";

export class SplashScene extends Phaser.Scene {

    public static currentInstance: SplashScene;

    private backgroundBlack: Phaser.GameObjects.Graphics;
    private adversariesInfoLayer: AdversariesInfoLayer;
    private rechargeTimeText: Phaser.GameObjects.Text;
    private playButtonContainer: Phaser.GameObjects.Container;
    private playButton: Button;
    private rechargeContainer: Phaser.GameObjects.Container;
    private watchAdButtonContainer: Phaser.GameObjects.Container;
    private creditsLabel: Phaser.GameObjects.Text;
    private languageButton: Button;
    private languageSelectionLayer: LanguageSelectionLayer;

    constructor() {

        super("SplashScene");

        SplashScene.currentInstance = this;
    }

    public create(): void {

        if (GameConstants.REWARDED_ADS) {
            window.advertisement = new GDAd();
            window.advertisement.init();
            window.advertisement.loadRewardedAd();
        }

        GameVars.currentScene = this;

        const background = new Background(this);
        this.add.existing(background);

        // LOS CREDITOS
        this.addCredits();

        if (GameConstants.REWARDED_ADS && window.advertisement.isRewardedAdReady()) {
            this.watchAdButtonContainer = this.add.container(280, 35);
            const watchAdButton = new Button(this, 0, 0, "texture_atlas_0", "adbutton_bg.png", "adbutton_bg.png", true, true);
            watchAdButton.scaleX = GameVars.scaleX;
            watchAdButton.onUp(this.onClickWatchAd, this);
            this.watchAdButtonContainer.add(watchAdButton);

            const watchAdText = new Phaser.GameObjects.Text(this, -30, 0, "+1000", { fontFamily: "Oswald-Medium", fontSize: "24px", color: "#622F20", align: "center" });
            watchAdText.setOrigin(.5);
            this.watchAdButtonContainer.add(watchAdText);

            const chipIcon = new Phaser.GameObjects.Image(this, watchAdText.x + watchAdText.displayWidth / 2 + 15, 2, "texture_atlas_1", "chip_pot_icon.png");
            chipIcon.setScale(.7);
            this.watchAdButtonContainer.add(chipIcon);

            const videoIcon = new Phaser.GameObjects.Image(this, chipIcon.x + chipIcon.displayWidth / 2 + 18, 2, "texture_atlas_0", "adbutton_icon.png");
            videoIcon.setScale(.9);
            this.watchAdButtonContainer.add(videoIcon);
        }

        const table = new Table(this);
        table.y = 380;
        table.setScale(.9 * GameVars.scaleX, .9);
        this.add.existing(table);

        const gameTitle = new GameTitleContainer(this);
        this.add.existing(gameTitle);

        const splashBanana = new SplashBanana(this);
        this.add.existing(splashBanana);

        // EL BOTON DE PLAY
        this.playButtonContainer = this.add.container(GameConstants.GAME_WIDTH / 2, 560);
        this.playButtonContainer.scaleX = GameVars.scaleX;

        this.playButton = new Button(this, 0, 0, "texture_atlas_1", "btn_yellow.png", "btn_yellow.png", true);
        this.playButton.onUp(this.onClickPlay, this);
        this.playButtonContainer.add(this.playButton);

        const playButtonLabel = new Phaser.GameObjects.Text(this, 0, -15, Translation.getText("PLAY_NOW"), { fontFamily: "Oswald-Medium", fontSize: "22px", color: "#622F20", align: "center" });
        playButtonLabel.setOrigin(.5);
        this.playButtonContainer.add(playButtonLabel);

        const roomPriceLabel = new Phaser.GameObjects.Text(this, - 10, 14, GameVars.formatNumber(GameConstants.ROOM_PRICE), { fontFamily: "Oswald-Medium", fontSize: "22px", color: "#622F20", align: "center" });
        roomPriceLabel.setOrigin(.5);
        this.playButtonContainer.add(roomPriceLabel);

        const chipIcon = new Phaser.GameObjects.Image(this, 36, 14, "texture_atlas_1", "chip_pot_icon.png");
        chipIcon.setScale(.9);
        this.playButtonContainer.add(chipIcon);

        // EL BOTON DE HI AND LO

        if (!GameVars.gameData.firstTime) {
            const hiLoButtonContainer = this.add.container(GameConstants.GAME_WIDTH / 2 + 105 * GameVars.scaleX, 565);
            hiLoButtonContainer.scaleX = GameVars.scaleX;

            const hiLoButton = new Button(this, 0, 0, "texture_atlas_1", "btn_hi-lo.png", "btn_hi-lo.png", true);
            hiLoButton.onUp(this.onClickHighLow, this);
            hiLoButtonContainer.add(hiLoButton);
            if (GameConstants.REWARDED_ADS) {
                hiLoButtonContainer.setVisible(false);
            } else {
                this.playButtonContainer.x = GameConstants.GAME_WIDTH / 2 - 85 * GameVars.scaleX;
            }

            if (GameVars.gameData.chips < GameConstants.ROOM_PRICE) {

                this.playButtonContainer.alpha = .5;
                this.playButton.input.enabled = false;

                this.tweens.add({
                    targets: hiLoButtonContainer,
                    scaleX: 1.05 * GameVars.scaleX,
                    scaleY: .95,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: 320,
                    repeat: -1,
                    yoyo: true
                });
            }

            const infoButtonContainer = this.add.container(35 * GameVars.scaleX, GameConstants.GAME_HEIGHT - 35);
            infoButtonContainer.scaleX = GameVars.scaleX;

            const infoButton = new Button(this, 0, 0, "texture_atlas_1", "btn_info_chars.png", "btn_info_chars.png", true);
            infoButton.onUp(this.showAdversariesInfoLayer, this);
            infoButtonContainer.add(infoButton);
        }

        const languageButton = new Button(this, GameConstants.GAME_WIDTH - 35 * GameVars.scaleX, GameConstants.GAME_HEIGHT - 35 * GameVars.scaleY, "texture_atlas_1", "btn_languages.png", "btn_languages.png", true);
        this.add.existing(languageButton);
        languageButton.scaleX = GameVars.scaleX;
        languageButton.onUp(this.showLanguagesLayer, this);

        this.languageSelectionLayer = new LanguageSelectionLayer(this, 0, 0);
        this.add.existing(this.languageSelectionLayer);
        this.languageSelectionLayer.scaleX = GameVars.scaleX;
        this.languageSelectionLayer.visible = false;


        const audioButton = new Phaser.GameObjects.Image(this, GameConstants.GAME_WIDTH - 35 * GameVars.scaleX, 35, "texture_atlas_1");

        if (GameVars.gameData.muted) {
            audioButton.setFrame("btn_sound_off.png");
        } else {
            audioButton.setFrame("btn_sound_on.png");
        }

        audioButton.setInteractive();

        audioButton.on("pointerdown", () => {
            audioButton.setScale(GameVars.scaleX, 1);
        }, this);

        audioButton.on("pointerup", () => {
            this.onDownAudioButton(audioButton);
        }, this);

        audioButton.on("pointerover", () => {
            audioButton.setScale(GameVars.scaleX * 1.05, 1.05);
        }, this);

        audioButton.on("pointerout", () => {
            audioButton.setScale(GameVars.scaleX, 1);
        }, this);

        audioButton.scaleX = GameVars.scaleX;
        this.add.existing(audioButton);

        if (!this.sys.game.device.os.desktop) {
            this.input.on("pointerup", () => {

                if (!this.game.scale.isFullscreen) {
                    this.game.scale.startFullscreen();
                    BootScene.onOrientationChange();
                }
            }, this);
        }

        const backgroundCover = new Background(this);
        this.add.existing(backgroundCover);

        this.tweens.add({
            targets: backgroundCover,
            alpha: 0,
            ease: Phaser.Math.Easing.Quadratic.Out,
            duration: 500,
            delay: 300,
            onComplete: function (): void {
                backgroundCover.destroy();
            },
            onCompleteScope: this
        });

        this.backgroundBlack = new Phaser.GameObjects.Graphics(this);
        this.backgroundBlack.fillStyle(0x000000, .9);
        this.backgroundBlack.alpha = 0;
        this.backgroundBlack.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        this.backgroundBlack.setInteractive(new Phaser.Geom.Rectangle(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT), Phaser.Geom.Rectangle.Contains);
        this.backgroundBlack.on("pointerdown", () => {
            //  
        });
        this.add.existing(this.backgroundBlack);

        this.adversariesInfoLayer = new AdversariesInfoLayer(this);
        this.add.existing(this.adversariesInfoLayer);

        AudioManager.playMusic("soundtrack_splash", .2);
    }

    public update(time: number, delta: number): void {

        if (GameVars.gameData.chips < GameConstants.ROOM_PRICE) {
            this.playButtonContainer.setAlpha(0.6);
            this.playButton.disableInteractive();
        } else {
            this.playButtonContainer.setAlpha(1);
            this.playButton.setInteractive();
        }
        if (this.rechargeTimeText) {
            this.rechargeTimeText.setText(this.remainingRechargeTimeFormatted());
        }
        if (this.canRewardRechargeAmount()) {
            this.rewardRechargeAmount();
        }
    }

    private showAdversariesInfoLayer(): void {

        AudioManager.playSound("btn_click");

        this.adversariesInfoLayer.visible = true;
    }

    private showLanguagesLayer() {
        AudioManager.playSound("btn_click");

        this.languageSelectionLayer.visible = true;
    }

    private addCredits(): void {

        const creditsContainer = this.add.container(100 * GameVars.scaleX, 35);
        creditsContainer.setScale(GameVars.scaleX * .8, .8);

        const w = 220;
        const h = 60;

        const creditsCartridge = new Phaser.GameObjects.Graphics(this);
        creditsCartridge.fillStyle(0x000000, .5);
        creditsCartridge.fillRoundedRect(-w / 2, -h / 2, w, h, h / 2);
        creditsContainer.add(creditsCartridge);

        this.creditsLabel = new Phaser.GameObjects.Text(this, w / 2 - 60, -2, GameVars.formatNumber(GameVars.gameData.chips), { fontFamily: "Oswald-Medium", fontSize: "46px", color: "#ffffff" });
        this.creditsLabel.setOrigin(1, .5);
        creditsContainer.add(this.creditsLabel);

        const chipIconCreditsLabel = new Phaser.GameObjects.Image(this, w / 2 - 30, 0, "texture_atlas_1", "chip_pot_icon.png");
        chipIconCreditsLabel.setScale(1.2);
        creditsContainer.add(chipIconCreditsLabel);

        if (!GameVars.gameData.firstTime && !GameConstants.REWARDED_ADS) {
            let moreButton = new Button(this, 225 * GameVars.scaleX, 35, "texture_atlas_1", "btn_add.png", "btn_add.png", true, true);
            moreButton.scaleX = GameVars.scaleX;
            moreButton.onUp(this.onClickHighLow, this);
            this.add.existing(moreButton);
        }

        if (GameConstants.REWARDED_ADS && GameVars.gameData.chips < GameConstants.ROOM_PRICE) {

            if (!this.isRewardTimeCounting()) {
                this.setNextRewardTime();
            }

            this.creditsLabel.setColor("#FF4356");

            this.rechargeContainer = this.add.container(100 * GameVars.scaleX, 85);
            this.rechargeContainer.setScale(GameVars.scaleX, 1);

            const rechargeCatridge = new Phaser.GameObjects.Graphics(this);
            rechargeCatridge.fillStyle(0x000000, .5);
            const rw = 176;
            const rh = h / 2;
            rechargeCatridge.fillRoundedRect(-rw / 2, -rh / 2, rw, rh, rh / 2);
            this.rechargeContainer.add(rechargeCatridge);

            const rechargeLabel = new Phaser.GameObjects.Text(this, -80, rechargeCatridge.y, "+500", { fontFamily: "Oswald-Medium", fontSize: "20px", color: "#ffffff" });
            rechargeLabel.setOrigin(0, .5);
            this.rechargeContainer.add(rechargeLabel);

            const rechargeChipsIcon = new Phaser.GameObjects.Image(this, -25, 2, "texture_atlas_1", "chip_pot_icon.png");
            rechargeChipsIcon.setScale(0.7);
            this.rechargeContainer.add(rechargeChipsIcon);

            this.rechargeTimeText = new Phaser.GameObjects.Text(this, 25, rechargeCatridge.y, this.remainingRechargeTimeFormatted(), { fontFamily: "Oswald-Medium", fontSize: "24px", color: "#ffffff", align: "right" });
            this.rechargeTimeText.setOrigin(0, .5);
            this.rechargeContainer.add(this.rechargeTimeText);

            if (this.canRewardRechargeAmount()) {
                this.rewardRechargeAmount();
            }
        }
    }

    private onClickWatchAd() {

        this.watchAdButtonContainer.setVisible(false);
        if (window.advertisement.isRewardedAdReady()) {
            window.advertisement.showRewardedAd(s => {
                if (s) {
                    GameVars.gameData.chips += 1000;
                    this.creditsLabel.setText(GameVars.formatNumber(GameVars.gameData.chips));
                    GameManager.writeGameData();
                }
            }, this);
        }
    }

    private onClickPlay(): void {
        this.playButtonContainer.setVisible(false);
        const loadingText = this.add.text(this.playButtonContainer.x - 20, this.playButtonContainer.y - 20, "...", { fontFamily: "Oswald-Medium", fontSize: "24px", color: "#FFFFFF", align: "center" }).setOrigin(0, 0.5);

        let i = 0;
        const texts = [".", "..", "...", "....", "....."];
        const c = setInterval(() => {
            loadingText.setText(texts[i++]);
            if (i >= texts.length) {
                i = 0;
            }
        }, 200);



        if (GameConstants.REWARDED_ADS) {
            window.advertisement.showAd(success => {
                this.tweens.add({
                    targets: this.backgroundBlack,
                    alpha: 1,
                    ease: Phaser.Math.Easing.Quadratic.In,
                    duration: 800,
                    onComplete: function (): void {
                        clearInterval(c);
                        GameManager.enterRoomScene();
                    },
                    onCompleteScope: this
                });

                AudioManager.playSound("btn_click");
            }, this);
        } else {
            clearInterval(c);
            GameManager.enterRoomScene();
        }
    }

    private onClickHighLow(): void {

        this.tweens.add({
            targets: this.backgroundBlack,
            alpha: 1,
            ease: Phaser.Math.Easing.Quadratic.In,
            duration: 800,
            onComplete: function (): void {
                GameManager.enterHiLoScene();
            },
            onCompleteScope: this
        });

        AudioManager.playSound("btn_click");
    }

    private onDownAudioButton(b: Phaser.GameObjects.Image): void {

        AudioManager.toggleAudioState();

        if (GameVars.gameData.muted) {
            b.setFrame("btn_sound_off.png");
        } else {
            b.setFrame("btn_sound_on.png");
        }

        AudioManager.playSound("btn_click");
    }

    private remainingRechargeTimeFormatted() {

        const nextRechargeTime = GameVars.gameData.nextChipRechargeAt;
        const now = Date.now();
        const difference = nextRechargeTime - now;

        const minutes = Math.floor(difference / (1000 * 60)) % 60;
        const seconds = Math.floor(difference / 1000) % 60;


        const formattedTime = `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;

        return formattedTime;
    }

    private isRewardTimeCounting() {

        return GameVars.gameData.nextChipRechargeAt !== 0;
    }

    private setNextRewardTime() {

        const rechargeTime = 30 * 60 * 1000;
        GameVars.gameData.nextChipRechargeAt = Date.now() + rechargeTime;
        GameManager.writeGameData();
    }

    private canRewardRechargeAmount() {

        if (GameVars.gameData.nextChipRechargeAt === 0) {
            return false;
        }
        if (GameVars.gameData.nextChipRechargeAt - Date.now() <= 0) {
            return true;
        } else {
            return false;
        }
    }

    private rewardRechargeAmount() {
        GameVars.gameData.chips += 500;
        GameVars.gameData.nextChipRechargeAt = 0;
        if (this.rechargeContainer) {
            this.rechargeContainer.setVisible(false);
        }
        GameManager.writeGameData();
    }
}
